import React, { useContext, useState, MouseEvent } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Box,
  Menu,
  Badge,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import Profile from "./Profile";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import Notification from "./Notification";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { PageDataContext, PageDataContextValue } from "../../utils/common/PageDataContext";
import { useSelector } from "react-redux";

// Type definitions
interface HeaderProps {
  handleDrawerToggle: () => void;
  handleDesktopToggle: () => void;
  desktopOpen: boolean;
}

interface UserParam {
  USERNAME?: string;
}

interface UserState {
  USER_PARAM?: UserParam;
}

interface RootState {
  user: UserState;
}

const Header: React.FC<HeaderProps> = ({
  handleDrawerToggle,
  handleDesktopToggle,
  desktopOpen,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state: RootState) => state.user) || {};
  const { USERNAME } = SYS_USER.USER_PARAM || {};

  const { pageData } = useContext(PageDataContext) as PageDataContextValue;

  // State for profile dropdown menu
  const [profileAnchorEl, setProfileAnchorEl] = useState<HTMLElement | null>(null);
  const profileOpen = Boolean(profileAnchorEl);

  // State for notification dropdown menu
  const [notificationAnchorEl, setNotificationAnchorEl] = useState<HTMLElement | null>(null);
  const notificationOpen = Boolean(notificationAnchorEl);

  // Handle profile menu open/close
  const handleProfileMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setProfileAnchorEl(event.currentTarget);
  };
  const handleProfileMenuClose = () => {
    setProfileAnchorEl(null);
  };

  // Handle notification menu open/close
  const handleNotificationMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setNotificationAnchorEl(event.currentTarget);
  };
  const handleNotificationMenuClose = () => {
    setNotificationAnchorEl(null);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        ...styles.header,
        width: { sm: `calc(100% - ${desktopOpen ? 240 : 0}px)` },
      }}
    >
      <Toolbar>
        <IconButton
          aria-label="toggle drawer"
          edge="start"
          onClick={handleDesktopToggle}
          sx={styles.headerHamburgerIcon}
        >
          <MenuOpenIcon />
        </IconButton>
        {/*page title  */}
        <Box sx={styles.title_container}>
          <Typography sx={styles.title_text}>{pageData.title}</Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }} />

        <Box display={"flex"} gap={2} alignContent={"center"}>
          <IconButton onClick={handleNotificationMenuOpen}>
            <Badge badgeContent={100} color="primary">
              <NotificationsIcon />
            </Badge>
          </IconButton>

          <Menu
            anchorEl={notificationAnchorEl}
            open={notificationOpen}
            onClose={handleNotificationMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={styles.headerNotificationMenu}
            MenuListProps={{
              sx: {
                paddingTop: 0,
                paddingBottom: 0,
                boxShadow: 1,
                padding: "1px",
                backgroundColor: "transparent",
              },
            }}
          >
            <Notification />
          </Menu>

          <Box sx={styles.boxHeaderProfile} onClick={handleProfileMenuOpen}>
            <Avatar
              alt="John Doe"
              src="https://storage.googleapis.com/a1aa/image/sEOZWreQ55qwQmRvi1gGJdVCTxq404PM_Rpw9wDBMug.jpg"
              sx={styles.headerImage}
            />
            <Typography
              sx={{
                fontSize: theme.typography.subtitle_s,
                color: theme.palette.text.primary,
              }}
            >
              {USERNAME}
            </Typography>
          </Box>

          <Menu
            anchorEl={profileAnchorEl}
            open={profileOpen}
            onClose={handleProfileMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={styles.headerProfileMenu}
            MenuListProps={{
              sx: {
                paddingTop: 0,
                paddingBottom: 0,
                boxShadow: 10,
                padding: "1px",
                backgroundColor: "transparent",
              },
            }}
          >
            <Profile />
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
